let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bvu0i")).then(() => parcelRequire('fzQQz'));